// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"profile-card_profileCard_3JO","avatarLink":"profile-card_avatarLink_O80","textLink":"profile-card_textLink_2XM","breakWords":"profile-card_breakWords_3aJ"};